//
// out of a list of images it picks the smallest image that has
// more pixels than required to fill both the height and width
// dimensions without considering the aspect ratio scaling of
// the image (if the image has an aspect ratio like 200x100,
// it will really fill a 200x100 box even if we have a 300x100
// space to put the image...  the coordinates supplied here
// are post-scaling
//

export const selectImage = (images, figureWidth, figureHeight) => {
    let verticalBig = 0;
    for (let i = 0; i < images.length; i++) {
        if (images[i].height < figureHeight)
            break;
        verticalBig = i;
    }
    let horizontalBig = 0;
    for (let i = 0; i < images.length; i++) {
        if (images[i].width < figureWidth)
            break;
        horizontalBig = i;
    }
    return images[Math.min(horizontalBig, verticalBig)]
}

export const fitImageToFigure = (imageDimension, figureDimension) => {
    const [imgX, imgY] = imageDimension
    const [figureX, figureY] = figureDimension
    const ratioX = imgX / figureX
    const ratioY = imgY / figureY
    if(ratioX>ratioY) {
        return [figureX, imgY / ratioX]
    } else {
        return [imgX / ratioY, figureY]
    }
}

export const isTallImage = (image, figureWidth, figureHeight) => {
    const ratio = image.height * figureWidth / (image.width * figureHeight)
    return ratio > 1
}

//
// world coordinates are like the (x,y) coordinate grid used in math class,
// that is increasing y moves a point upward, unlike coordinate in HTML/CSS
//

export const worldBoundingBox = (cards) => {
    const lefts = cards.map(card => card.position[0] - card.size[0]/2)
    const rights = cards.map(card => card.position[0] + card.size[0]/2)
    const bottoms = cards.map(card => card.position[1] - card.size[1]/2)
    const tops = cards.map(card => card.position[1] + card.size[1]/2)
    return {
        left: Math.min(...lefts),
        right: Math.max(...rights),
        bottom: Math.min(...bottoms),
        top: Math.max(...tops)
    }
}

export const toWorldCoordinates = (position, imgSize, worldBoundingBox) => {
    const worldX = worldBoundingBox.left + position[0] / imgSize[0] * ( worldBoundingBox.right - worldBoundingBox.left)
    const worldY = worldBoundingBox.top + position[1] / imgSize[1] * ( worldBoundingBox.bottom - worldBoundingBox.top)
    return [ worldX, worldY ]
}

export const locateImage = (cards, worldPosition) => {
    for(const card of cards) {
        if(Math.abs(worldPosition[0] - card.position[0]) > card.size[0] / 2)
            continue

        if(Math.abs(worldPosition[1] - card.position[1]) <= card.size[1] / 2)
            return card
    }
    return null
}

export const createCardLocator = (cards, imgSize) => {
    const boundingBox = worldBoundingBox(cards)
    const toWorld = (position) => toWorldCoordinates(position, imgSize, boundingBox)
    return (position) => locateImage(cards, toWorld(position))
}
